/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useContext, useEffect, useState } from 'react';

import { Auth, Hub } from 'aws-amplify';
import CustomLoginHeader from '../components/Auth/CustomLoginHeader';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';
import api from '../api/Api';
import { toast } from 'react-toastify';
import styles from './withAuthentication.module.scss';
import { captureException } from '@sentry/minimal';
import { getRelevantTranslationFor } from './multiLingualTools';
import { SET_CONTEXT } from '../context/globalState/globalStateReducer';
import GlobalStateContext from '../context/globalState/GlobalStateContext';
import { CampaignContext } from '../@types/seen-apps';
import { CampaignResponse } from '../@types/shorten-url-api';
import LoadingPage from '../pages/loading/LoadingPage';
import CustomLoginFooter from '../components/Auth/CustomLoginFooter';
import { useLocation } from 'react-router-dom';

export function withAuthentication<T>(
  WrappedComponent: React.ComponentType<T>
) {
  return (props: any) => {
    const location = useLocation();

    const { dispatch } = useContext(GlobalStateContext);
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | undefined>(
      undefined
    );
    const [campaign, setCampaign] = useState<CampaignResponse | undefined>(
      undefined
    );
    const [isLoading, setLoading] = useState<boolean>(true);

    const [cookiesAccepted, setCookiesAccepted] = useState<boolean>(
      window.localStorage.getItem('cookiesAccepted') === 'true'
    );
    const [showEnterCode, setShowEnterCode] = useState<boolean>(false);
    const [forceShowConnection, setForceShowConnection] =
      useState<boolean>(false);
    const { t } = useTranslation('i18n');

    const checkIsGuestRoute = async () => {
      const url = new URL(window.location.href);

      const validationCode = url.searchParams.get('validationCode') || '';
      const campaignId = url.searchParams.get('campaignId');
      if (!validationCode) {
        return;
      }

      if (campaignId) {
        try {
          const campaign = await api.getCampaign(campaignId, validationCode);
          setCampaign(campaign);
          if (dispatch) {
            dispatch({
              type: SET_CONTEXT,
              payload: {
                campaignCtx: {
                  campaign,
                  validationCode,
                } as CampaignContext,
              },
            });
          }
        } catch (error) {
          toast.error(t('common.invalid'));
        }
      }
    };

    const handleCookiesAccepted = async () => {
      window.localStorage.setItem('cookiesAccepted', 'true');
      setCookiesAccepted(true);
    };
    const checkUserConnected = async (e: any) => {
      try {
        await Auth.currentSession();
        setIsAuthenticated(true);
        setLoading(false);
      } catch (error) {
        captureException(error);
        setIsAuthenticated(false);
        const url = new URL(window.location.href);
        const active = url.searchParams.get('active') || '';
        const showEnterCode = active === 'enterCode';
        if (showEnterCode) {
          setShowEnterCode(true);
          setLoading(false);
        } else {
          await checkIsGuestRoute();
          setLoading(false);
        }
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
      checkUserConnected(undefined);
      Hub.listen('auth', checkUserConnected);

      return () => {
        Hub.remove('auth', checkUserConnected);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleHaveAccountClicked = (e: any) => {
      e.preventDefault();
      setForceShowConnection(true);
    };

    const handleCreateAccountClicked = async (e: any) => {
      e.preventDefault();

      setLoading(true);
      const access = await api.createGuestAccess({
        link: location.pathname,
      });

      await Auth.signIn({
        password: access.password,
        username: access.userName,
      });
      localStorage.setItem('forceRegistration', 'true');
    };

    // const campaign = state?.context?.campaignCtx?.campaign;
    const acceptGuest = campaign?.category === 'consumer';
    return isLoading ? (
      <LoadingPage />
    ) : (
      <>
        <ToastContainer
          autoClose={5000}
          hideProgressBar
          newestOnTop
          transition={Slide}
          draggable={false}
        />
        {isAuthenticated !== undefined && (
          <CustomLoginHeader
            isAuthenticated={isAuthenticated}
            acceptGuest={acceptGuest}
            providerName={getRelevantTranslationFor(
              campaign?.providerName || ''
            )}
            showEnterCode={showEnterCode}
          />
        )}

        {(forceShowConnection ||
          !(isAuthenticated === false && (acceptGuest || showEnterCode))) && (
          <WrappedComponent {...props} />
        )}

        {isAuthenticated === false && acceptGuest && !forceShowConnection && (
          <div className={styles.haveAccount}>
            {t('login.Have an account? ')}
            <a href='#' onClick={handleHaveAccountClicked}>
              {t('login.Sign in')}
            </a>
          </div>
        )}

        {isAuthenticated === false && !acceptGuest && !showEnterCode && (
          <CustomLoginFooter onCreateAccount={handleCreateAccountClicked} />
        )}

        {!cookiesAccepted && (
          <CookieConsent
            disableStyles={true}
            onAccept={handleCookiesAccepted}
            location='bottom'
            containerClasses='consent alert-warning'
            buttonClasses='btn btn-consent'
            contentClasses='text-consent'
            buttonText={t('app.consent.accept')}
          >
            {t('app.consent.message')}{' '}
            <a
              target='_blank'
              style={{ color: '#857025', textDecoration: 'underline' }}
              href='https://www.seen-apps.com/terms'
            >
              {t('app.consent.termsAndConditions')}
            </a>
          </CookieConsent>
        )}
      </>
    );
  };
}
